import React, { FunctionComponent } from 'react';

import { closeCurrentPopup } from '@paragon/popup-state';

import { cancelInsertion } from '../../store/actions/insertActions';
import { useAppDispatch } from '../hooks';
import { ConfirmCancel } from './ConfirmCancel';

export const ConfirmCancelInsertionDialog: FunctionComponent = () => {
  const dispatch = useAppDispatch();

  return (
    <ConfirmCancel
      onClose={(confirmed) => {
        dispatch(closeCurrentPopup());
        if (confirmed) dispatch(cancelInsertion());
      }}
    />
  );
};
